<template>
    <div>
        <p
            v-if="label != null"
            class="text-14 pb-1 transition-all duration-300 ease-in-out"
            :class="[disabled ? 'text-grey-600' : 'text-grey-900']"
        >
            {{ label }}
        </p>

        <div class="input-group" :class="[boxClass, [error ? 'border-error' : 'border-grey-500'], [disabled ? 'disabled' : '']]">
            <div
                class="input !h-12 !pt-0 flex items-center"
                :class="{
                    'text-grey-600': disabled,
                }"
            >
                <button
                    :disabled="disabled"
                    class="relative h-full link-text hover:cursor-pointer text-purple-600 text-14 disabled:text-grey-600 disabled:hover:underline disabled:cursor-default"
                    v-show="uploadedFileName == null && lUpload == null"
                    type="button"
                    @click="$refs.input.click()"
                    :class="{
                        'text-grey-600 no-underline': disabled,
                    }"
                >
                    <p class="z-10 block">Choose file</p>

                    <input
                        ref="input"
                        :disabled="disabled"
                        :name="name"
                        v-if="lUpload == null"
                        :placeholder="placeholder"
                        type="file"
                        autocomplete="off"
                        class="opacity-0 absolute inset-0 !cursor-pointer z-[-1] appearance-none"
                        @blur="inputBlur"
                        @focus="inputFocused"
                        @input="update"
                        @change="fileUploaded"
                    />

                    <input type="hidden" :name="name" value="uploaded" v-else />

                    <input type="hidden" :name="name" :value="null" v-if="uploadedFileName == null" />
                </button>

                <p
                    v-show="uploadedFileName != null || lUpload != null"
                    class="text-14"
                    :class="{
                        'text-grey-600': disabled,
                    }"
                >
                    {{ uploadedFileName }}
                </p>
            </div>

            <slot :isFocused="isFocused" name="right" />

            <button class="pr-2.5" type="button" v-if="uploadedFileName != null || lUpload != null" @click="remove">
                <IconClose
                    class="w-4.5 h-4.5 icon-hover"
                    :class="{
                        '!stroke-grey-600 hover:!stroke-grey-600': disabled,
                    }"
                />
            </button>
        </div>

        <Error v-if="!hideError" :error="error">
            <template #errorAfter>
                <slot name="errorAfter" :error="error" />
            </template>
        </Error>
    </div>
</template>

<script>
import Input from '~/mixins/input.js'

export default {
    mixins: [Input],

    props: {
        upload: Object,
    },

    data() {
        return {
            lUpload: this.upload,
            uploadedFileName: this.upload != null ? this.upload.file_name : null,
        }
    },

    methods: {
        fileUploaded(event) {
            // console.log(event)
            this.uploadedFileName = event.target.files[0].name
        },

        remove() {
            this.uploadedFileName = null
            this.lUpload = null
            this.$refs.input.value = null
        },
    },
}
</script>
